<template>
  <div class="maindiv">
    <a-affix :offset-top="0">
      <div class="heading m-display-flex flex-row space-between width-full nowrap">
        <h2 class="title-top">
          PPIS
        </h2>
        <img
            keep-alive
            class="m-drawer-brand"
            src="@/assets/logo.png"
            alt="brand"
          />
      </div>
    </a-affix>
    <div id="subdiv" class="subdiv">
      <div class="popovermenu">
        <a-popover title="Select Cost Center" trigger="click" placement="rightTop">
          <template slot="content">
            <a-config-provider :locale="getLocalConfigProvider()">
              <a-select
                mode="tags"
                placeholder="Please select"
                v-model="acceptedItem"
                class="m-width-full"
              >
                <a-select-option
                  showSearch
                  v-for="item in acceptedItemList"
                  :key="item"
                  >{{ item }}</a-select-option
                >
              </a-select>
            </a-config-provider>
            <a-divider style="margin: 24px 0 0px 0"></a-divider>
            <a-form-model ref="filter" :model="formFilter" :rules="formRules" :layout="'inline'">
              <div style="display:flex">
                <div style="display:flex;padding-top: 8px;align-items: center;justify-content: center;"><b>Spent Time :</b>&nbsp;</div>
                <a-form-model-item prop="day_start">
                  <a-input-number v-model="formFilter.day_start" :min="1" class="m-text-align-right" @keydown="onlyNumber"/>
                  &nbsp;Between&nbsp;
                  <a-input-number v-model="formFilter.day_end" :min="1" class="m-text-align-right" @keydown="onlyNumber"/>
                  &nbsp;Days&nbsp;
                  <!-- <a-button type="primary" class="margin-top" @click="handleApplyFilter">Apply</a-button> -->
                </a-form-model-item>
              </div>
            </a-form-model>
            <a-button type="primary" class="margin-top" @click="handleApply">Apply</a-button>
          </template>
          <a-icon type="caret-right"></a-icon>
        </a-popover>
      </div>
      <div>
        <div class="card-container" v-if="isFine">
            <a-tabs type="card" :class="(index==0 ? 'tabular' : 'tabular tabbed') + ' ' + item.kode_project + (item.last_project ? ' lastProject' : '')" v-for="(item,index) in datalist" :key="index + '_' +item.kode_project">
              <a-tab-pane :key="index" :tab="item.kode_project">
                <a-table
                  bordered
                  size="small"
                  :rowKey="(record, index) => { return index;}"
                  :columns="kolom"
                  :data-source="item.detil"
                  :pagination="false"
                  :rowClassName="(record, index) => { return record.overmonth == '1' ? 'redRow' : (record.overmonth == '2' ? 'yellowRow' : 'fontbold') }"
                >
                  <span slot="nopp" slot-scope="element">
                    <span>{{ element.no_pp }}</span><br/>
                    <span>{{ element.pembuat }} | {{ formatCurrency(element.currency,element.estimated_value) }}</span>
                    <span v-if="element.currency!='IDR'"> ( {{ formatCurrency('IDR',element.rp_value) }} )</span>
                  </span>
                  <span slot="deskripsi"  slot-scope="element">
                    <span style="word-wrap: break-word;">{{ element.deskripsi }}</span>
                  </span>
                  <span slot="wfpic" slot-scope="element">
                    <span>{{ (element.actor=='Keuangan' && element.status=='Not Yet Allocated') ? element.status : element.actor}}</span><br/>
                    <span>{{ (element.actor=='Keuangan' && element.status=='Not Yet Allocated') ? element.actor : element.tlc }}</span>
                  </span>
                  <span slot="spentime" slot-scope="element">
                    <span>{{ moment(element.tanggal_aksi).format(getDefaultDateFormat) }}</span><br/>
                    <span>{{ element.duration ? element.duration.replace('Hari', 'Days') : '' }}</span>
                  </span>
                  <div slot="footer" class="tabbed-footer">
                    <h3 style="margin-bottom: 0;"><b>Total : {{ formatCurrency('IDR',item.total_rp) }}</b></h3>
                  </div>
                </a-table>
              </a-tab-pane>
            </a-tabs>
            <div style="width:100%;height:120px">

            </div>
        </div>
        <div class="card-container" v-else>
          <div style="display: flex;flex-direction:column;height:100vh;justify-content: center;align-items: center;">
            <m-anim
              :options="notfound"
              class="anim"
              :height="getScreen ? 200 : 500"
              :width="getScreen ? 200 : 500"
            ></m-anim>
            <h1 class="margin-remove">404</h1>
            <h3 class="margin-bottom">Error Connection, please contact your administrator</h3>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import GlobalMethod from "@/mixins/GlobalMethod.js";
import CurrencyFormat from "@/mixins/CurrencyFormat";
import moment from "moment";
import lottie from "vue-lottie";
import notfound from "@/assets/anim/404.json";
import _ from "lodash";
import VueCookies from 'vue-cookies'

export default {
  name: "PP_DashBoard",
  components: { "m-anim": lottie },
  mixins: [GlobalMethod,CurrencyFormat],
  data(){
    const kolom = [
      {
        title: "No. PP",
        key: "nopp",
        align: "left",
        width:"27%",
        scopedSlots: { customRender: "nopp" },
      },
      {
        title: "Description",
        key: "description",
        scopedSlots: { customRender: "deskripsi" },
        align: "left",
        width:"43%",
      },
      {
        title: "WF /PIC",
        key: "wfpic",
        scopedSlots: { customRender: "wfpic" },
        align: "left",
        width:"17%",
      },
      {
        title: "Spent Time",
        key: "spentime",
        scopedSlots: { customRender: "spentime" },
        align: "left",
        width:"13%",
      },
    ];
    return {
      kolom,
      datalist : [],
      functionInterval: null,
      acceptedItem: [],
      acceptedItemList: [],
      timer: null,
      timerinfinite: null,
      formFilter: {
        day_start: null,
        day_end: null
      },
      formRules: {
        day_start: [{ required: false, message: "Spentime start is required!" }],
        day_end: [{ required: false, message: "Spentime end is required!" }],
      },
      notfound: { animationData: notfound, loop: true },
      isFine: true,
      scrollisActive: false
    }
  },
  mounted(){
    Event.$on("restartScrollingAfterWheel", this.restartScrollAfterWheel);

    this.handleOnMouseWheel()

    let tempItem = VueCookies.get('ppdashbd')
    if(tempItem){
      this.acceptedItem = tempItem;
    }

    let tempfilterItem = VueCookies.get('ppfilterdashbd')
    if(tempfilterItem){
      this.formFilter.day_start = tempfilterItem.start;
      this.formFilter.day_end = tempfilterItem.end;
    }
    this.fetch('once');
  },
  beforeDestroy() {
    Event.$off("restartScrollingAfterWheel", this.restartScrollAfterWheel);
  },
  computed: {
    ...mapGetters(["getDefaultDateFormat", "getStandartFormatDate","getScreen"]),
  },
  methods: {
    moment, 
    fetch(params){
      this.scrollisActive = false
      this.asyncAxiosGet("public_dashboard/wf_pp",
        null,
        {
          start: this.formFilter.day_start,
          end: this.formFilter.day_end,
        }
      ).then((res) => {
          this.isFine = true
          this.acceptedItemList = res.data.map(a => a.kode_project);
          let tempacceptedItem = VueCookies.get('ppdashbd')
          let tempfilterItem = VueCookies.get('ppfilterdashbd')
          if(!tempacceptedItem){
            tempacceptedItem = [];
          }
          if(tempacceptedItem.length>0){
            if(params=='once'){
              this.datalist = [];
            }
            
            let templist = []
            res.data.forEach((element) => {
              if(tempfilterItem){
                if(tempacceptedItem.find((temp) => temp == element.kode_project)){
                  let tempmain = {
                    jml: element.jml,
                    kode_project: element.kode_project,
                    total_rp: element.total_rp,
                    overscreen: false,
                    last_project: false,
                    detil : []
                  }
                  tempmain.detil = element.detil.filter((obj) => parseInt(obj.duration)>=tempfilterItem.start && parseInt(obj.duration)<=tempfilterItem.end)
                  
                  if(tempmain.detil.length>0){
                    templist.push(tempmain)
                  }
                }else{
                  let a = this.datalist.findIndex((arr) => { return arr.kode_project==element.kode_project})
                    if(a>=0){
                      this.datalist.splice(a,1)
                    }
                }
              }
            })
            templist[templist.length-1].last_project = true
            if(params=='once'){
              let ls = [...templist]
              templist = templist.concat(ls)
              this.datalist = templist
            }else{
              let ls = [...templist]
              this.datalist = this.datalist.concat(ls)
            }
          }else{
            let temp = res.data
            temp[temp.length-1]['last_project'] = true
            let ls = [...temp]
            temp = temp.concat(ls)
            this.datalist = temp;
          }
          if(params=='once'){
            document.getElementById("subdiv").scrollTop = 0
            clearInterval(this.functionInterval)
            clearTimeout(this.timer)
            this.executeScroll();
          }
          this.scrollisActive = true
      }).catch((err) => {
        this.scrollisActive = false
        // this.isFine = false
        this.loading = false;
        let response = Object.assign({}, err.response);
        if(response.length){
          if (response.data.status == false && response.data.message) {
            this.displayMessageValue("error-other", response.data.message);
          } else {
            let responses = Object.assign({}, err.response.data);
            this.displayMessageValue("error", responses);
          }
        }else{
          // this.datalist = [];
          this.scrollisActive = true
          clearInterval(this.functionInterval)
          clearTimeout(this.timer)
          this.executeScroll();
          // this.timer = setTimeout(
          //   function () {
          //     this.executeScroll();
          //   }.bind(this),
          //   3000
          // ) ;
        }
      });
    },
    executeScroll(){
      clearInterval(this.scroller)
      this.functionInterval = setInterval(this.scroller, 50);
    },
    scroller(){
      if(this.scrollisActive){
        document.getElementById("subdiv").scrollBy(0, 1);
        this.recalc()
      }
    },
    handleApply(){
      if(this.acceptedItem.length>0){
        VueCookies.set('ppdashbd' , this.acceptedItem, "1y")
      }else{
        VueCookies.remove('ppdashbd')
      }
      this.handleApplyFilter()
      this.$router.go(0);
    },
    handleApplyFilter(){
      this.$refs.filter.validate((valid) => {
        if (!valid) {
          this.displayMessage("form-warning");
          return;
        }

        if(this.formFilter.day_start > this.formFilter.day_end){
          this.displayMessageValue("error-other", "Spentime start must be grather than spentime end!");
        }else{
          let temfilter = {
            start: this.formFilter.day_start,
            end: this.formFilter.day_end
          }
          VueCookies.set('ppfilterdashbd' , temfilter, "1y")
          this.$router.go(0);
        }
      })
    },
    createWheelStopListener(element, callback, timeout) {
        var handle = null;
        var onScroll = function() {
            if (handle) {
                clearTimeout(handle);
            }
            handle = setTimeout(callback, timeout || 200); // default 200 ms
        };
        element.addEventListener('wheel', onScroll);
        return function() {
            element.removeEventListener('wheel', onScroll);
        };
    },
    restartScrollAfterWheel(){
      clearInterval(this.functionInterval)
      clearTimeout(this.timer)
      this.timer = setTimeout(
        function () {
          this.executeScroll();
        }.bind(this),
        3000
      ) ;
    },
    handleOnMouseWheel(){
      this.createWheelStopListener(window, function() {
        Event.$emit("restartScrollingAfterWheel");
      })
    },
    isVisible(ele, container) {
        const { bottom, height, top } = ele.getBoundingClientRect();
        const containerRect = container.getBoundingClientRect();

        // return top <= containerRect.top ? containerRect.top - top <= height : bottom - containerRect.bottom <= height;
        return top <= containerRect.top ? containerRect.top - top <= height : true;
    },
    recalc(){
      let elSubdiv = document.getElementById("subdiv")
      let trigger = false
      let eltabs = document.getElementsByClassName('lastProject')[0]
      let a = this.isVisible(eltabs,elSubdiv)
      if(!a)
        trigger = true

      if(trigger){
        let cls = eltabs.className
        cls = cls.split(' ')
        cls = cls[cls.length-2]
        
        let indx = _.findIndex(this.datalist, {kode_project: cls})
        this.datalist.splice(indx+1,1)
        this.fetch('infinite')
        elSubdiv.scrollTop = 0
      } else if(Math.abs(elSubdiv.scrollHeight - elSubdiv.clientHeight - elSubdiv.scrollTop) <= 1){
        this.scrollisActive = false
        this.timer = setTimeout(
          function () {
            this.fetch("infinite");
          }.bind(this),
          3000 //3 detik
        ) ;
      }
    },
  },
}
</script>

<style lang="less">
.heading {
    padding         : @padding;
    background-image: linear-gradient(to bottom right, @color-primary, darken(@color-primary, 40));
    display         : flex;
    flex-direction  : column;
    flex-wrap       : nowrap;
    align-items     : flex-end;
    justify-content : center;
    line-height     : 1;
    width           : 100%!important;
    position        : relative;
    z-index         : 999;

    // * {
    //     color: white;
    // }

    &:after {
        content             : '';
        position            : absolute;
        background-image    : url('~@/assets/Pattern.png');
        top                 : 0;
        right               : 0;
        bottom              : 0;
        width               : 100%;
        background-repeat   : no-repeat;
        background-size     : contain;
        background-position : right;
        opacity             : 0.4;
    }
  }
.title-top{
  color:white
}

.tabbed{
  padding-top:18px;
}

.card-container {
  //background: #f5f5f5;
  overflow: hidden;
  scroll-behavior: smooth;
  // padding: 0px 18px 18px 18px;
}
.card-container > .ant-tabs-card > .ant-tabs-content {
  //height: 120px;
  margin-top: -16px;
}

.card-container > .ant-tabs-card > .ant-tabs-content > .ant-tabs-tabpane {
  background: #fff;
  padding: 16px;
}

.card-container > .ant-tabs-card > .ant-tabs-bar {
  border-color: #fff;
}

.card-container > .ant-tabs-card > .ant-tabs-bar .ant-tabs-tab {
  border-color: transparent;
  background: transparent;
}

.card-container > .ant-tabs-card > .ant-tabs-bar .ant-tabs-tab-active {
  border-color: #fff;
  background: #fff;
}

// Scroll bar
/* width */
::-webkit-scrollbar {
  width: 3px;
}

/* Track */
::-webkit-scrollbar-track {
  background: #b1b1b1; 
}
 
/* Handle */
::-webkit-scrollbar-thumb {
  background: #383838; 
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #141414; 
}
// Scroll bar

html {
  scroll-behavior: smooth;
}

body {
  overflow: hidden;
}

.subdiv {
  height:100vh;
  overflow-y: auto;
}

.popovermenu{
  position  : sticky;
  top       : 0px;
  opacity   : 0;
  z-index   : 1000;

  &:hover{
    opacity: 1;
    cursor: pointer;
  }
}

.tabbed-footer {
  vertical-align: middle;
  text-align:right;
}

.redRow{
  background-color: #ea8c8c !important;
  color: white;
  font-weight: bold;

  &:hover{
    color : rgba(0, 0, 0, 0.85);
    font-weight: normal;
  }
}

.yellowRow{
  background-color: #fcffb2 !important;
  font-weight: bold;

  &:hover{
    color : rgba(0, 0, 0, 0.85);
    font-weight: normal;
  }
}

.fontbold{
  font-weight: bold;
}
.card-container > .ant-tabs-card > .ant-tabs-content > .ant-tabs-tabpane {
  padding: 12px 0 12px 0;
}
</style>
